export function resolveAuthRedirect(rawRedirect: string | null, fallback = '/'): string {
  if (!rawRedirect?.startsWith('/') || rawRedirect.startsWith('//')) {
    return fallback
  }

  return rawRedirect
}
